package ru.it_mozaika.sender.common.models

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

@Serializable
object EmailMessageStatus {
    const val CREATED = 0
    const val DELAYED = 1
    const val PROCESS = 2
    // TODO: convert statuses in DB
    const val SEND = 3
    const val DELIVERY_DELAY = 4
    const val DELIVERY = 5
    const val ERROR = 6
    const val OPEN = 7
    const val CLICK = 8
    const val REVIEW = 9
    const val UNSUBSCRIBED = 10

    val titles = mapOf(
        0 to "Создан",
        1 to "Отложен",
        2 to "В процессе",
        3 to "Отправлен",
        4 to "Задержка доставки",
        5 to "Доставлено",
        6 to "Ошибка",
        7 to "Письмо открыто",
        8 to "Нажата ссылка",
        9 to "Нажали оставить отзыв",
        10 to "Отписались"
        )
}

@Serializable
enum class EmailType {
    Confirmation,
    Campaign,
    Trigger,
    TriggerAction,
    Test,
    Template,
    Custom,
    System
}

/**
 * WARNING! DataClass names is used as values in EmailMessageEvent Table, column 'eventType'
 * Change with notion
 * */
@Serializable
sealed class EmailMessageEvent {
    @Contextual
    abstract val timestamp: Instant
    @Serializable
    data class Review(
        @Contextual override val timestamp: Instant,
        val rating: Float,
        val description: String? = null
    ): EmailMessageEvent()
    @Serializable
    data class Send(
        @Contextual override val timestamp: Instant,
    ) : EmailMessageEvent()

    @Serializable
    data class Delivery(
        @Contextual override val timestamp: Instant,
    ) : EmailMessageEvent()

    @Serializable
    data class Open(
        @Contextual override val timestamp: Instant,
        val ipAddress: String,
        val userAgent: String
    ) : EmailMessageEvent()

    @Serializable
    data class Click(
        @Contextual override val timestamp: Instant,
        val ipAddress: String,
        val userAgent: String,
        val linkIndex: Int,
        val url: String
    ) : EmailMessageEvent()

    @Serializable
    data class Reject(
        @Contextual override val timestamp: Instant,
        val reason: String
    ) : EmailMessageEvent()

    @Serializable
    data class Bounce(
        @Contextual override val timestamp: Instant,
        val bounceType: BounceType,
        val bounceSubType: BounceSubType,
        val description: String? = null
    ) : EmailMessageEvent()

    @Serializable
    data class Complaint(
        @Contextual override val timestamp: Instant,
        val complaintFeedbackType: ComplaintType?,
    ) : EmailMessageEvent()

    @Serializable
    data class RenderingFailure(
        @Contextual override val timestamp: Instant,
        val templateName: String,
        val errorMessage: String,
    ) : EmailMessageEvent()

    @Serializable
    data class DeliveryDelay(
        @Contextual override val timestamp: Instant,
        val delayType: String,
    ) : EmailMessageEvent()

    @Serializable
    data class Unsubscribe(
        @Contextual override val timestamp: Instant = Clock.System.now(),
        val reason: String = ""
    ) : EmailMessageEvent()
}


@Serializable
enum class BounceType {
    Undetermined,
    Permanent,
    Transient
}

@Serializable
enum class BounceSubType {
    Undetermined,
    General,
    NoEmail,
    Suppressed,
    OnAccountSuppressionList,
    MailboxFull,
    MessageTooLarge,
    ContentRejected,
    AttachmentRejected
}

@Serializable
enum class ComplaintType {
    Abuse,
    AuthFailure,
    Fraud,
    NotSpam,
    Other,
    Virus;

    companion object {
        fun valueOfAwsField(value: String?): ComplaintType? = when (value) {
            "abuse" -> Abuse
            "auth-failure" -> AuthFailure
            "fraud" -> Fraud
            "not-spam" -> NotSpam
            "other" -> Other
            "virus" -> Virus
            else -> null
        }
    }
}

@Serializable
data class Quarantine(
    val email: String,
    val quarantineType: QuarantineType,
    @Contextual val date: Instant,
    val messageId: String
)

@Serializable
enum class QuarantineType {
    Bounce,
    Complaint,
}

@Serializable
data class SendEmailRequest(
    val email: String = "",
    val template: String = "",
    val sender: String = "",
    val store: String = "",
    val data: List<EmailDataValue> = listOf()
)

@Serializable
data class EmailDataValue(
    val key: String,
    val value: String
)

@Serializable
data class SendRawEmailRequest(
    val email: String = "",
    val template: String = "",
    val sender: String = "",
    val store: String = "",
    val data: List<EmailDataValue> = listOf()
)

@Serializable
data class EmailMessage(
     val id: String,
     val store: String,
    val subscriberData: String,
    val email: String,
    val type: EmailType = EmailType.Custom,
   val typeId: String? = null,
    val variant: Int,
    val status: Int,
    val events: List<EmailMessageEvent> = listOf(),
)